/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: NL (Dutch; Nederlands, Vlaams)
 */
jQuery.extend(jQuery.validator.messages, {
	required: "Verplicht",
	remote: "Controleer dit veld",
	email: "Geldig e-mailadres",
	url: "Vul hier een geldige URL in",
	date: "Vul hier een geldige datum in",
	dateISO: "Vul hier een geldige datum in (ISO-formaat)",
	number: "Vul hier een geldig getal in",
	digits: "Vul hier alleen getallen in",
	creditcard: "Vul hier een geldig creditcardnummer in",
	equalTo: "Niet identiek",
	accept: "Vul hier een waarde in met een geldige extensie",
	maxlength: jQuery.validator.format("Vul hier maximaal {0} tekens in"),
	minlength: jQuery.validator.format("Minimaal {0} tekens"),
	rangelength: jQuery.validator.format("Vul hier een waarde in van minimaal {0} en maximaal {1} tekens"),
	range: jQuery.validator.format("Vul hier een waarde in van minimaal {0} en maximaal {1}"),
	max: jQuery.validator.format("Vul hier een waarde in kleiner dan of gelijk aan {0}"),
	min: jQuery.validator.format("Vul hier een waarde in groter dan of gelijk aan {0}")
});